export default __webpack_public_path__ + "static/ITIL-e39c35f81f90cd8c45ee0c09c8fa55f1.png";